import { FilterOption } from '#service/autocomplete-service/option';

class ProjectExpirationOptionService {
  getOptionsRaw() {
    return [
      { label: 'All projects', value: '0', id: '0', default: true },
      { label: 'Active only', value: '1', id: '1' }
    ];
  }

  async fetchOptionsRaw(value, fetchOptions, ids) {
    const options = this.getOptionsRaw();

    if (ids) {
      const idsArray = ids.length > 1 ? ids.join(',') : [ids];
      const filteredArray = options.filter(option => idsArray.includes(option.value));

      return filteredArray;
    }

    return options;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}

export default ProjectExpirationOptionService;
